import { Link } from "@chakra-ui/react";
import { motion } from "framer-motion";
import PropTypes from "prop-types";

const MotionLink = motion(Link);

export const BaseLink = ({ withMotion, innerRef, ...props }) => {
  // TODO: Temporary to make links testable locally
  if (process.env.NODE_ENV !== "production") {
    const href =
      props.href.replace("http://remember-next.azurewebsites.net", "") ||
      props.href ||
      "";
    props = {
      ...props,
      href,
    };
  }

  const withRef = innerRef ? { ref: innerRef } : {};

  return (
    <Link {...withRef} {...props}>
      {props.children}
    </Link>
  );
};

BaseLink.propTypes = {
  href: PropTypes.string,
  children: PropTypes.node,
  innerRef: PropTypes.any,
  /** Set to true if Framer Motion is needed for animating */
  withMotion: PropTypes.bool,
};
